// Module
var code = `<div ng-class="\$ctrl.heightClass || 'h-75'"></div> <div class="mt-2 flex flex-wrap items-center gap-2"> <button type="button" class="btn-flat border border-gray-300 text-gray-700" ng-click="\$ctrl.removeLastPoint()" ng-disabled="!\$ctrl.canRemoveLastPoint()" translate> fieldPolygonMap.REMOVE_LAST_POINT </button> </div> `;
// Exports
export default code;